export default __webpack_public_path__ + "static/upiOptions4-24c2d4d308e724cae5d48ab7975534f6.webm";